export default "<img src=\"/assets/404.png\" width=\"100%\" style=\"min-height: 100vh; object-fit: cover\">\r\n"